module.exports = __webpack_public_path__ + "static/media/army.034fc5a1.png";